export enum DragParent {
    statusPanelDetail = 0,
    techPanelDetail = 1,
    techCalendar = 2,
}

